'use client';

import Box from '@mui/material/Box';
import {Typography} from '../primitives';

export interface StatItemProps {
  label: string;
  value: string;
}

export function StatItem({label, value}: StatItemProps) {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', textAlign: 'center'}}>
      <Typography
        size="title-1"
        weight="semiBold"
        mobileSize="title-4"
        mobileWeight="semiBold"
        as="p"
        sx={{textTransform: 'capitalize', color: theme => theme.palette.colors.text.primary.inverse}}
      >
        {value}
      </Typography>
      <Typography
        size="body-2"
        weight="medium"
        mobileSize="body-3"
        mobileWeight="medium"
        as="p"
        sx={theme => ({
          color: theme.palette.colors.text.neutral.inverseMuted,
          textTransform: 'uppercase',
          letterSpacing: 0,
          [theme.breakpoints.down('md')]: {textTransform: 'uppercase', letterSpacing: 0},
        })}
      >
        {label}
      </Typography>
    </Box>
  );
}

StatItem.displayName = 'StatItem';
